import { ref, reactive, computed, watch, onUnmounted, onMounted, onBeforeUnmount, onActivated, onDeactivated } from "vue";
import type { Ref, ComputedRef } from "vue";
import { findIndex, sortBy, debounce } from "lodash-es";

import type { DataTableColumnType, UseScrollLoadDataType } from "../types";

interface TablePropsType {
  scrollToLoadMoreData: boolean;
  scrollToLoadMoreDataLength: number;
  rowHeight: number;

  data: any[];
}

export function useScrollLoadData(
  props: TablePropsType,
  willShowListData: ComputedRef<any[]>
): UseScrollLoadDataType {
  const tableScrollWrapEl = ref<HTMLDivElement | null>(null);
  const startIndex = ref<number>(props.scrollToLoadMoreDataLength);

  const isScrollToRender = computed(() => {
    return props.scrollToLoadMoreData && props.rowHeight > 0;
  });

  const isScrollRenderData = computed(() => {
    if (!isScrollToRender.value) return [];
    return willShowListData.value.slice(0, startIndex.value);
  });
  const remainingData = computed(() => {
    console.log(willShowListData);
    if (!isScrollToRender.value) return [];
    const endIndex = willShowListData.value.length;
    return willShowListData.value.slice(startIndex.value, endIndex);
  });

  const placeholderHeight = computed(() => {
    if (!isScrollToRender.value) return "0px";
    const remainingRowCount =
      willShowListData.value.length - remainingData.value.length;
    return remainingRowCount * props.rowHeight + "px";
  });

  const handleScroll = debounce(() => {
    const scrollContainer: any = tableScrollWrapEl.value;
    if (!scrollContainer) return;
    if (startIndex.value >= willShowListData.value.length) return;
    const placeholder = scrollContainer.querySelector(".loading-more-data");
    if (!placeholder) return;

    const placeholderRect = placeholder.getBoundingClientRect();
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    console.log(placeholderRect.bottom, scrollContainerRect.bottom);
    const data: any[] = willShowListData.value;
    if (
      placeholderRect.bottom - scrollContainerRect.bottom <
      props.rowHeight * props.scrollToLoadMoreDataLength
    ) {
      console.log("loadEnd");
      if (startIndex.value + props.scrollToLoadMoreDataLength > data.length) {
        startIndex.value = data.length;
      } else {
        startIndex.value += props.scrollToLoadMoreDataLength;
      }
    }
  }, 50);

  onMounted(() => {
    if (isScrollToRender.value) {
      tableScrollWrapEl.value?.addEventListener("scroll", handleScroll);
    }
  });

  onBeforeUnmount(() => {
    tableScrollWrapEl.value?.removeEventListener("scroll", handleScroll);
  });
  watch(
    () => props.data,
    () => {
      startIndex.value = props.scrollToLoadMoreDataLength;
    }
  );
  onActivated(() => {
    (tableScrollWrapEl.value as any).scrollTop = 0;
  });
  onDeactivated(() => {
    startIndex.value = props.scrollToLoadMoreDataLength;
  });
  return {
    isScrollToRender,
    tableScrollWrapEl,
    isScrollRenderData,
    remainingData,
    placeholderHeight,
  };
}
